import { type Card, evaluate5 } from '@tctp/engine/browser';

/** The five cards, out of up to seven, that make the strongest hand (the first best subset on a tie). */
export function bestFive(cards: readonly Card[]): Card[] {
  if (cards.length <= 5) return [...cards];
  let best: Card[] = []; let bestValue = -1;
  const n = cards.length;
  for (let a = 0; a < n; a++) for (let b = a + 1; b < n; b++) for (let c = b + 1; c < n; c++) for (let d = c + 1; d < n; d++) for (let e = d + 1; e < n; e++) {
    const five = [cards[a]!, cards[b]!, cards[c]!, cards[d]!, cards[e]!];
    const value = evaluate5(five);
    if (value > bestValue) { bestValue = value; best = five; }
  }
  return best;
}

/** The showdown highlight: every card that makes a winning hand, with its tilt. */
export interface Highlight { used: Set<Card>; tilt: Map<Card, number> }

/** A small random tilt per highlighted card, −4° … 4°, drawn once per hand so re-renders keep it. */
export function tilts(cards: Iterable<Card>): Map<Card, number> {
  const out = new Map<Card, number>();
  for (const c of cards) out.set(c, Math.round((Math.random() * 8 - 4) * 10) / 10);
  return out;
}
